import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1.5),
    position: 'relative',
  },
  section: {
    marginBottom: theme.spacing(2),
  },
}));

const ScriptStepSkeletonLoader = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <Skeleton variant="text" />
        <Skeleton variant="text" width={'75%'} />
      </div>
      <div className={styles.section}>
        <Skeleton variant="text" />
        <Skeleton variant="text" width={'75%'} />
      </div>
    </div>
  );
};

export default ScriptStepSkeletonLoader;
